import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";

export default function TableFooter() {
    const {
        shortcodes,
        currentShortcodes,
        itemsPerPage,
        currentPage,
        totalPages,
        setCurrentPage,
    } = useRulesContext();

    return (
        <div className="px-4 sm:px-6 py-5 bg-gray-50 border-t border-gray-200 rounded-b-xl">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-sm text-gray-500">
                    {`${__(
                        "Showing",
                        "wpbean-quantity-controls-for-woocommerce",
                    )} ${currentShortcodes.length} ${__(
                        "of",
                        "wpbean-quantity-controls-for-woocommerce",
                    )} ${shortcodes.length} ${__(
                        "rules",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}`}
                </div>

                <div className="flex items-center space-x-2">
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {__(
                            "Previous",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                            className={`px-3 py-1 text-sm rounded ${
                                currentPage === i + 1
                                    ? "bg-blue-600 text-white"
                                    : "text-gray-600 hover:text-gray-800"
                            }`}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {__("Next", "wpbean-quantity-controls-for-woocommerce")}
                    </button>
                </div>
            </div>
        </div>
    );
}
